// useFittingSession.js
//
// Thin React binding for fittingSessionStore.js. Returns the current
// snapshot and re-renders the caller whenever the store changes — same
// shape as a useState value, except the underlying state lives outside
// this (or any) component, so it isn't lost when DataFittingPage unmounts
// on route change and remounts later.
import { useEffect, useState } from 'react';
import { getFittingSessionState, subscribeFittingSession } from './fittingSessionStore';

export function useFittingSession() {
  const [session, setSession] = useState(getFittingSessionState());
  useEffect(() => subscribeFittingSession(setSession), []);
  return session;
}